import { memo, useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection, $isTextNode } from 'lexical';
import { useSelector } from 'react-redux';
import setWorkflowActiveInputState from '../../screens/workflows/redux/actions/setWorkflowActiveInputState';

const SelectionStatePlugin = memo(() => {
  const [editor] = useLexicalComposerContext();
  const activeWorkflowInputSelection = useSelector((state) => state?.workflow?.activeInputState?.selection);

  useEffect(() => {
    return editor.registerUpdateListener(() => {
      editor.getEditorState().read(() => {
        const selection = $getSelection();
        let text = '';
        let offset = 0;
        if ($isRangeSelection(selection) && $isTextNode(selection.anchor.getNode())) {
          const anchorNode = selection.anchor.getNode();
          text = anchorNode.getTextContent();
          offset = selection.anchor.offset;
        }
        if (activeWorkflowInputSelection?.text !== text || activeWorkflowInputSelection?.offset !== offset) {
          setWorkflowActiveInputState({
            selection: { text, offset }
          });
        }
      });
    });
  }, [editor, activeWorkflowInputSelection]);

  return null;
});

SelectionStatePlugin.displayName = 'SelectionStatePlugin';

export default SelectionStatePlugin;
